import {Skeleton, Tooltip} from 'antd';
import styles from './metricCard.module.scss';

/**
 * Compact metric tile used across the referral partner surfaces.
 * `tone` tints the value: 'default' | 'brand' | 'positive' | 'muted'.
 */
const MetricCard = ({
  label,
  value,
  hint,
  caption,
  tone = 'default',
  loading,
}) => (
  <div className={styles.card}>
    <div className={styles.labelRow}>
      <span className={styles.label}>{label}</span>
      {hint && (
        <Tooltip title={hint}>
          <span className={styles.hint}>?</span>
        </Tooltip>
      )}
    </div>
    {loading ? (
      <Skeleton.Input active size="small" className={styles.skeleton} />
    ) : (
      <>
        <div className={`${styles.value} ${styles[tone]}`}>{value}</div>
        {caption && <div className={styles.caption}>{caption}</div>}
      </>
    )}
  </div>
);

export default MetricCard;
